import {
  GET_WEB_ORDER_PENDING,
  GET_WEB_ORDER_SUCCESSFUL,
  GET_WEB_ORDER_ERROR
} from './constants'

var initialState = {
  pending: true,
  successful: true,
  error: null,
  data: {
    attributes: {
      items: []
    }
  }
}

export default function webOrder (
  state = initialState,
  { type, response, error }
) {
  switch (type) {
    case GET_WEB_ORDER_PENDING:
      return {
        ...state,
        pending: true,
        successful: false,
        error: null
      }
    case GET_WEB_ORDER_SUCCESSFUL:
      return {
        ...state,
        data: response.data,
        pending: false,
        successful: true,
        error: null
      }
    case GET_WEB_ORDER_ERROR:
      return {
        ...state,
        pending: false,
        successful: false,
        error: response
      }
    default:
      return state
  }
}
